import React from "react"
import { useTranslation } from "react-i18next"

import { TeamPerson } from "~/api/types/TeamPerson"

import { Link } from "../Link/Link"
import { LinksBundle } from "../LinksBundle/LinksBundle"
import { Quote } from "../Quote/Quote"
import { Raw } from "../raw"
import styles from "./index.module.css"

export const TeamCardMain: React.FC<{ inCommittee?: boolean } & TeamPerson> = ({
  code,
  detailPicture,
  name,
  position,
  quote,
  committee,
  inCommittee,
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <a className={styles.Link} href={`/about/team/${code}`} />

      <div className={styles.Photo}>
        <img src={detailPicture} />
      </div>

      <div>
        <div dangerouslySetInnerHTML={{ __html: name }} className={styles.Name} />

        {position && <div dangerouslySetInnerHTML={{ __html: position }} className={styles.Job} />}

        {quote !== null && (
          <Quote view="small">
            <Raw html={quote} />
          </Quote>
        )}

        {committee.length > 0 && inCommittee && (
          <div className={styles.Committees}>
            <div
              className={styles.CommitteeHeading}
              dangerouslySetInnerHTML={{ __html: t("committee.TeamCardMain.Committee.Heading") }}
            />

            <LinksBundle>
              {committee.map(({ id, code, name }) => (
                <Link
                  key={id}
                  href={
                    id !== "64935"
                      ? `/about/corpmanage/${code}`
                      : "/investors-and-shareholders/committee-investor-relations"
                  }
                  view="arrow"
                >
                  <Raw html={name} />
                </Link>
              ))}
            </LinksBundle>
          </div>
        )}
      </div>
    </div>
  )
}
